import { render, staticRenderFns } from "./Pharmacist.vue?vue&type=template&id=18f4795e&scoped=true&"
import script from "./Pharmacist.vue?vue&type=script&lang=js&"
export * from "./Pharmacist.vue?vue&type=script&lang=js&"
import style0 from "./Pharmacist.vue?vue&type=style&index=0&id=18f4795e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f4795e",
  null
  
)

export default component.exports